import { authService } from '@/services/app/auth.service';
import { alertHelper } from '@/utils';
import i18n from '@/i18n';
import { sharedHelper, sessionHelper } from '@/utils';
import { SESSION } from "@/constants";
import { authLoginModel } from "@/models/app/authLogin.model";

const user = JSON.parse(localStorage.getItem('user'));

export const state = {
    status: {
        loggeduser: true,
        save: true,
    }, 
    user,
};

export const AUTH_MODULE = 'app/auth';

// ACTIONS
export const LOGIN = 'login';
export const REFRESH = 'REFRESH';
export const LOGOUT = 'logout';

export const LOGIN_OTP_REQUEST = 'loginOtpRequest';
export const LOGIN_OTP_VERIFY = 'loginOtpVerify';
export const FORGOT_PASSWORD_OTP_REQUEST = 'forgotPasswordOtpRequest';
export const FORGOT_PASSWORD_OTP_VERIFY = 'forgotPasswordOtpVerify';
export const RESET_PASSWORD_VERIFY = 'resetPasswordVerify';

// MUTATIONS
const REQUESTING = "requesting";
const LOGIN_SUCCESS = "loginSuccess";
const LOGOUT_SUCCESS = "logout";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REFRESH_SUCCESS = "refreshSuccess";

export const getters = {
    loggedIn(state) {
        return !!state.user
    },
};

export const actions = {
    [LOGIN_OTP_REQUEST] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .loginOtpRequest(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [LOGIN_OTP_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .loginOtpVerify(data)
            .then((result) => {
                commit(SUCCESS);
                if (result?.success) {
                    alertHelper.alertSuccess({message: i18n.t('message.loginSuccess')});
                    commit(LOGIN_SUCCESS, result);
                }
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [FORGOT_PASSWORD_OTP_REQUEST] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .forgotPasswordOtpRequest(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [FORGOT_PASSWORD_OTP_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .forgotPasswordOtpVerify(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [RESET_PASSWORD_VERIFY] ({ commit }, { data }) {
        commit(REQUESTING, 'save');
        return authService
            .resetPasswordVerify(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },


    [LOGIN] ({ commit }, { data }) {
        commit(REQUESTING);
        return authService
            .login(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.loginSuccess')});
                commit(LOGIN_SUCCESS, result);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                alertHelper.alertError({message: message, title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [REFRESH] ({ commit }, { data }) {
        commit(REQUESTING);
        authService
            .refresh(data)
            .then((result) => {
                console.log(result);
                commit(REFRESH_SUCCESS, result);
            })
            .catch((error) => {
                let message = sharedHelper.getErrorMessage(error);
                alertHelper.alertError({message: message, title: i18n.t('message.error')});
                commit(FAILURE, error);
            });
    },
    [LOGOUT] ({ commit }) {
        commit(LOGOUT_SUCCESS);
        // authService
        //     .logout()
        //     .then((result) => {
        //         console.log(result);
        //         alertHelper.alertSuccess({message: i18n.t('message.logoutSuccess')});
        //         commit(LOGOUT_SUCCESS);
        //     })
        //     .catch((error) => {
        //         let message = sharedHelper.getErrorMessage(error);
        //         alertHelper.alertError({message: message, title: i18n.t('message.error')});
        //         commit(FAILURE, error);
        //     });
    },
};

export const mutations = {
    [REQUESTING] (state, type) {
        if (type) {
            state.status[type] = false;
            return;
        }
        state.status = { loggeduser: false };  
    },
    [SUCCESS] (state) {
        state.status = { loggeduser: true, save: true };
    },
    [FAILURE] (state) {
        state.status = { save: true };
    },
    [LOGIN_SUCCESS] (state, data) {
        const user = authLoginModel(data.data);

        state.status = { loggeduser: true, save: true };
        state.user = user;

        var tokenExpiredTime = sessionHelper.calculateTime(user.token.expiresAt);
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.token.refreshExpiresAt);

        localStorage.setItem(SESSION.JWT_TOKEN, user.token.accessToken);
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiredTime);
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime);
        localStorage.setItem(SESSION.USER_NAME, user.user.fullName || `${user.user.firstName || ''} ${user.user.lastName || ''}`.trim());
        localStorage.setItem(SESSION.USER, JSON.stringify(user));
        localStorage.setItem(SESSION.USER_TYPE, 'app');

        window.location.href = '/';
    },
    [LOGOUT_SUCCESS] (state) {
        sessionHelper.clearAllClientStorage()
        state.status = {};
        state.user = null;

        window.location.href = '/';
    },
    [REFRESH_SUCCESS] (state, user) {
        state.status = {};

        var tokenExpiredTime = sessionHelper.calculateTime(user.data.token.expires_in);
        var refreshTokenExpiredTime = sessionHelper.calculateTime(user.data.token.refresh_expires_in);

        localStorage.setItem(SESSION.JWT_TOKEN, user.data.token.access_token);
        localStorage.setItem(SESSION.TOKEN_EXPIRY_TIME, tokenExpiredTime);
        localStorage.setItem(SESSION.REFRESH_TOKEN_EXPIRY_TIME, refreshTokenExpiredTime);
        localStorage.setItem(SESSION.PERMISSIONS, JSON.stringify(user.data.user.roles[0].permissions));
        localStorage.setItem(SESSION.USER_NAME, user.data.user.name);
        localStorage.setItem(SESSION.USER, JSON.stringify(user));
    },
};
